<template>
	<div class="bg-white px-3 goods_create" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;overflow-y: scroll;height: 78vh;">
		<router-link :to="{name:'cwgl_srjz_skdd'}" style="position: absolute;top: 12px;left: 200px;">
			<el-button size="mini">回到收款订单</el-button>
		</router-link>

		<el-form ref="form" label-width="80px" style="margin-left: 20px;">
			<div class="d-flex pt-a">
				<div style="width: 35%;">
					<el-form-item label="交易号">
						<el-input :disabled="true" v-model="lists.jyh"></el-input>
					</el-form-item>
					<el-form-item label="业务员">
						<el-select v-model="lists.ywy" filterable style="width: 90%;">
						    <el-option v-for="item in ywylist" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="客户">
						<el-select v-model="lists.kh" filterable style="width: 90%;">
						    <el-option v-for="item in khlist" :key="item.id" :label="item.mc" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="收入类别">
						<el-select v-model="lists.srlb" filterable style="width: 90%;">
						    <el-option v-for="item in srlblist" :key="item.id" :label="item.mc" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="上传凭据">
						<div>
							<span v-if="!lists.scpj" class="btn btn-light border mr-2" @click="chooseImage">
								<i class="el-icon-upload"></i>
							</span>
							<img v-else :src="lists.scpj" class="rounded" style="width: 100px;height: 100px;cursor: pointer;" @click="chooseImage" />
						</div>
					</el-form-item>
				</div>
				<div style="width: 33%;">
					<el-form-item label="单据类型">
						<el-input v-model="lists.djlx" :disabled="true"></el-input>
					</el-form-item>
					<el-form-item label="部门">
						<el-select v-model="lists.bm" filterable style="width: 90%;">
						    <el-option v-for="item in bmlist" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="供应商">
						<el-select v-model="lists.gys" filterable style="width: 90%;">
						    <el-option v-for="item in gyslist" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="收款账户">
						<el-select v-model="lists.skzh" filterable style="width: 90%;">
						    <el-option v-for="item in cwzjlist" :key="item.id" :label="item.mc" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
				</div>
				<div style="width: 33%;">
					<el-form-item label="备注">
						<el-input v-model="lists.desc" style="width: 95%;"></el-input>
					</el-form-item>
					<el-form-item label="项目">
						<el-select v-model="lists.xm" filterable style="width: 90%;">
						    <el-option v-for="item in xmlist" :key="item.id" :label="item.mc" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="是否挂账">
						<el-radio-group v-model="lists.sfgz">
						      <el-radio-button :label="0">否</el-radio-button>
						      <el-radio-button :label="1">是</el-radio-button>
						    </el-radio-group>
					</el-form-item>
					<el-form-item label="收入金额">
						<el-input-number v-model="lists.szje"  :precision="2" class="w-50"></el-input-number>
					</el-form-item>
				</div>
			</div>
		</el-form>

		<el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 250px;right: 0;z-index: 100;justify-content: center;">
			<el-button type="primary" @click="submit">提交</el-button>
		</el-footer>

	</div>
</template>

<script>
	import common from '@/common/mixins/common.js';
	export default {
		mixins: [common],
		inject: ['app', 'layout'],

		data() {
			return {
				lists: {},
				xmlist:[],
				ywylist:[],
				khlist:[],
				gyslist:[],
				bmlist:[],
				cwzjlist:[],
				xxddcp:[],
				srlblist:[]
			}
		},
		created() {
			this.lists = this.$route.params.data;
			this.axios.get('/admin/managers/list', { token: true }).then(res => {
				this.ywylist = res.data.data;
			});
			this.axios.get('/admin/qtxms', { token: true }).then(res => {
				this.xmlist = res.data.data;
			});
			this.axios.get('/admin/khxxs', { token: true }).then(res => {
				this.khlist = res.data.data;
			});
			this.axios.get('/admin/gyss', { token: true }).then(res => {
				this.gyslist = res.data.data;
			});
			this.axios.get('/admin/bumens/list', { token: true }).then(res => {
				this.bmlist = res.data.data;
			});
			this.axios.get('/admin/cwzjs', { token: true }).then(res => {
				this.cwzjlist = res.data.data;
			});
			this.axios.get('/admin/cwszsk', { token: true }).then(res => {
				this.srlblist = res.data.data;
			});
		},
		methods: {
			chooseImage() {
				this.app.chooseImage((res) => {
					this.lists.scpj = res[0].url
				}, 1)
			},
			
			//提交
			submit() {
				let url = !this.lists.id == true ? '/admin/skddcw' : '/admin/skddcw/' + this.lists.id
				this.axios.post(url, this.lists, {
					token: true
				}).then(res => {
					console.log(res.data)
					this.$message({
						type: "success",
						message: !this.lists.id == true ? "创建成功" : "修改成功"
					})
					this.$router.push({
						name: "cwgl_srjz_skdd"
					})
				}).catch(err => {
				})
			}
		},
	}
</script>

<style>
	.goods_create .el-form-item {
		margin-bottom: 15px;
	}
	.pt-a{
		padding-top: 20px;
	}

</style>
